/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { TreeCheckbox, TreeCheckboxProps } from '../tree/TreeCheckbox';
import { QUESTION } from '../../constants/terminology';

interface AssuranceQuestionModalProps extends TreeCheckboxProps {
  isOpen: boolean;
}

export const AssuranceQuestionModal = ({ toggle, isOpen, initiativeId, portfolioId, surveyId, afterSubmit }: AssuranceQuestionModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='assurance-question-modal' size='lg'>
      <ModalHeader toggle={toggle}>Add/Remove Survey {QUESTION.CAPITALIZED_PLURAL}</ModalHeader>
      <ModalBody>
        {isOpen && <TreeCheckbox initiativeId={initiativeId} toggle={toggle} afterSubmit={afterSubmit} portfolioId={portfolioId} surveyId={surveyId} />}
      </ModalBody>
    </Modal>
  );
};
